<template>
  <v-container
    class="pt-3"
    v-touch="{
      down: () => swipeRefresh()
    }"
  >
    <FullscreenDialog
      title=""
      v-model="personalisation"
    >
      <template slot="content">
        <NewsFilter />
      </template>
    </FullscreenDialog>
    <FullscreenDialog
      title=""
      v-model="openNewsDetail"
    >
      <template slot="content">
        <NewsInfo
          :news-item="newsObj"
          :school-images="schoolsLogo"
        />
      </template>
      <template slot="action">
        <v-btn
          icon
          color="white"
          @click="externalLink(newsObj.url)"
        >
          <v-icon>mdi-earth</v-icon>
        </v-btn>
        <v-btn
          icon
          color="white"
          @click="openShareSheet(newsObj.url, newsObj.title)"
        >
          <v-icon>mdi-share-variant-outline</v-icon>
        </v-btn>
      </template>
    </FullscreenDialog>
    <v-row v-if="retrieveSchoolStatusError">
      <v-col>
        <v-card
          class="status-card"
          flat
          outlined
        >
          <div class="flex-grow-1 text-left school-name px-4 pb-2 pt-3">
            <div class="d-flex">
              <v-icon
                color="warning"
                size="22"
                class="mr-3"
              >
                mdi-alert
              </v-icon>
              <h3
                class="font-weight-medium"
                style="font-size: 18px"
              >
                {{ $t("news.operationalStatusTitle") }}
              </h3>
            </div>
            <v-list class="py-0">
              <v-list-item class="mx-n4 border-bottom">
                <div
                  class="d-flex align-start font-weight-medium text--primary text-body-2"
                  style="letter-spacing: 0 !important"
                >
                  <v-icon class="mr-3">
                    mdi-help-circle-outline
                  </v-icon>
                  <span style="line-height: 1.2">
                    The operational status of your school(s) cannot be retrieved
                    at this time
                  </span>
                </div>
              </v-list-item>
            </v-list>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="nonOperational && nonOperational.length > 0">
      <v-col>
        <v-card
          class="status-card"
          flat
          outlined
        >
          <div class="flex-grow-1 text-left school-name px-4 pb-2 pt-3">
            <div class="d-flex">
              <v-icon
                color="warning"
                size="22"
                class="mr-3"
              >
                mdi-alert
              </v-icon>
              <h3
                class="font-weight-medium"
                style="font-size: 18px"
              >
                {{ $t("news.operationalStatusTitle") }}
              </h3>
            </div>
            <v-list class="py-0">
              <template v-for="(school, index) in nonOperational">
                <div :key="'nonOperational' + index">
                  <v-list-item class="mx-n4 border-bottom">
                    <v-list-item-content>
                      <v-list-item-title
                        class="font-weight-bold"
                        style="font-size: 14px;"
                      >
                        {{ school.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle
                        class="d-flex align-center text-body-1 font-weight-medium text--primary"
                        style="letter-spacing: 0 !important"
                      >
                        <v-icon color="warning">
                          mdi-minus-circle-outline
                        </v-icon>
                        <span class="warning--text mx-1">
                          {{ $t("mySchool.status.nonOperational") }}
                        </span>
                        {{
                          $t("mySchool.status.asOfDate", {
                            date: new Date(
                              school.lastUpdated
                            ).toLocaleDateString(locale, {
                              day: "numeric",
                              month: "numeric",
                              year: "numeric"
                            })
                          })
                        }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider v-if="index + 1 < nonOperational.length" />
                </div>
              </template>
            </v-list>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="showPersonalisationCard">
      <v-col>
        <v-card
          class="personalisation-card white--text"
          flat
          outlined
          color="primary"
        >
          <div class="flex-grow-1 text-left school-name px-4 py-3">
            <div class="d-flex align-start mb-5">
              <v-icon
                color="white"
                size="55"
                class="mr-3 mt-n1"
              >
                mdi-filter-variant
              </v-icon>
              <div
                class="text-body-1"
                style="line-height: 1.2"
              >
                {{ $t("news.personaliseNews") }}
              </div>
              <div class="d-flex flex-grow-1 justify-end">
                <v-icon
                  @click="hidePersonalisationCard(false)"
                  color="white"
                >
                  close
                </v-icon>
              </div>
            </div>
            <v-btn
              color="white"
              class="primary--text"
              style="min-width: 165px"
              large
              elevation="0"
              @click="hidePersonalisationCard(true)"
            >
              {{ $t("news.personaliseNewsCta") }}
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="totalItems === 0">
      <v-col
        cols="8"
        offset="2"
        class="text-center mt-12 subtitle-1"
      >
        {{ $t("news.noArticles") }}
      </v-col>
      <v-col cols="12">
        <AdsButton
          :button-text="$t('news.reload')"
          color="error"
          block
          class="mt-3"
          @click="applyFilters()"
        />
      </v-col>
    </v-row>
    <v-row v-if="totalItems > 0">
      <v-col>
        <div
          v-infinite-scroll="loadNews"
          infinite-scroll-disabled="busy"
          infinite-scroll-distance="1"
          infinite-scroll-immediate-check="false"
        >
          <NewsList
            :items="groupNews"
            @openNewsDialog="showNewsDetails"
            :school-images="schoolsLogo"
          />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import NewsList from "../components/NewsList";
import { FullscreenDialog, AdsButton } from "@nswdoe/doe-ui-core";
import NewsInfo from "../components/NewsInfo";
import { mapGetters } from "vuex";
import groupBy from "lodash/groupBy";
import NewsFilter from "../components/NewsFilter";
import features from "../features.json";
import {
  FA_SCREEN_VIEW,
  FA_SCREEN_NAME,
  FA_SCREEN_CLASS
} from "../settings/constants";

const News = {
  computed: {
    ...mapGetters([
      "news",
      "schoolsLogo",
      "mySchools",
      "appFilters",
      "schoolStatus",
      "article",
      "showPersonalisationCard",
      "mySchools"
    ]),
    items: function() {
      return this.news.items;
    },
    totalItems: function() {
      return this.news.total;
    },
    groupNews: function() {
      if (this.items && this.items.length > 0) {
        let sortedNews = this.items.sort(function(a, b) {
          // move pinned events to the top
          if (a.pinned) {
            return -1;
          } else {
            return -1 * (new Date(a.created) - new Date(b.created));
          }
        });
        return groupBy(sortedNews, news => {
          if (news.pinned) {
            return this.$t("news.featured");
          } else if (this.getToday(news.created)) {
            return this.$t("news.today");
          } else if (this.getYesterday(news.created)) {
            return this.$t("news.yesterday");
          } else {
            return this.$t("news.earlier");
          }
        });
      } else {
        return null;
      }
    },
    retrieveSchoolStatusError: function() {
      return !this.schoolStatus.results;
    },
    nonOperational: function() {
      return (
        this.schoolStatus.results &&
        this.schoolStatus.results.filter(school => !this.isOperational(school))
      );
    },
    appBuild: function() {
      return this.getCookie("appbuild");
    },
    locale: function() {
      return this.getLocale() == 'en' ? 'en-au' : this.getLocale()
    }
  },
  components: {
    FullscreenDialog,
    NewsInfo,
    AdsButton,
    NewsList,
    NewsFilter
  },
  name: "News",
  title: "News",
  mounted: function() {
    //eslint-disable-next-line
    NativeJS.debugLog("test debug on news page load");
    if (this.$route.params.id) {
      if (this.$route.query.returnRoute) {
        this.$watch("openNewsDetail", function() {
          if (!this.openNewsDetail) {
            this.$router.push(
              decodeURIComponent(this.$route.query.returnRoute)
            );
          }
        });
      }
      this.$store
        .dispatch("getIndividualNews", this.$route.params.id)
        .then(() => {
          this.$router.push("/news");
          this.showNewsDetails(this.article);
        })
        .catch(() => {
          this.error = true;
        });
    } else {
      this.analytics(FA_SCREEN_VIEW, {
        [FA_SCREEN_CLASS]: "news",
        [FA_SCREEN_NAME]: "news_feed"
      });

      this.$store.dispatch("getNews", {
        page: this.page,
        itemsPerPage: this.itemsPerPage
      });

      // move to home screen when new flow is implemented
      this.$store.dispatch("fetchNotifications");
    }
  },
  data() {
    return {
      itemsPerPage: 10,
      page: 1,
      infiniteScrollBusy: false,
      openNewsDetail: false,
      newsObj: {},
      personalisation: false
    };
  },
  methods: {
    showNewsDetails(newsItem) {
      this.$store.dispatch("setArticleRead", newsItem.id);
      this.analytics(FA_SCREEN_VIEW, {
        [FA_SCREEN_CLASS]: "news",
        [FA_SCREEN_NAME]: newsItem.title.replaceAll(" ", "_")
      });
      this.openNewsDetail = true;
      this.newsObj = newsItem;
    },
    loadNews() {
      this.infiniteScrollBusy = true;
      if (this.page * this.itemsPerPage > this.totalItems) {
        this.infiniteScrollBusy = false;
        return;
      }
      this.page = this.page + 1;
      this.$store.dispatch("getNews", {
        page: this.page,
        itemsPerPage: this.itemsPerPage
      });
      this.infiniteScrollBusy = false;
    },
    applyFilters() {
      this.page = 1;
      this.$store.dispatch("getNews", {
        page: this.page,
        itemsPerPage: this.itemsPerPage
      });
    },
    swipeRefresh() {
      if (window.pageYOffset === 0) {
        this.$store.dispatch("getNews", {
          page: this.page,
          itemsPerPage: this.itemsPerPage
        });
      }
    },
    externalLink(link) {
      //eslint-disable-next-line
      NativeJS.debugLog(`opening external link (${link})`);
      //eslint-disable-next-line
      NativeJS.externalLink(link);
    },
    openShareSheet(url, title) {
      //eslint-disable-next-line
      NativeJS.debugLog(`sharing ${title} at url ${url}`);
      //eslint-disable-next-line
      NativeJS.openShareSheet(url, title);
    },
    isOperational(data) {
      if (this.hasPassed(data.operationalDate)) {
        return !data.nonOperational;
      } else {
        return data.nonOperational;
      }
    },
    hasPassed(dateString) {
      let date = new Date(dateString);
      let today = new Date();
      return date <= today;
    },
    getToday(dateString) {
      return new Date(dateString).toLocaleDateString("en-us") ===
        new Date().toLocaleDateString("en-us")
        ? true
        : false;
    },
    getYesterday(dateString) {
      let yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      return new Date(dateString).toLocaleDateString("en-us") ===
        yesterday.toLocaleDateString("en-us")
        ? true
        : false;
    },
    hidePersonalisationCard(togglePersonalisation) {
      if (togglePersonalisation) {
        this.personalisation = true;
      }
      this.$store.dispatch("togglePersonalisationCard", false);
    },
    schoolName(id) {
      if (id != "global") {
        return this.mySchools.find(school => school.schoolId == id)?.details
          .name;
      }

      return "NSW Department of Education";
    },
    schoolCode(id) {
      if (id != "global") {
        return this.mySchools.find(school => school.schoolId == id)?.schoolCode;
      }

      return "NSW Department of Education";
    }
  },
  watch: {
    appFilters: {
      deep: true,
      handler() {
        this.applyFilters();
      }
    },
    openNewsDetail: {
      handler(newValue) {
        // trigger on close of dialog
        if (!newValue) {
          this.$store.dispatch("removeArticle");
          this.$store.dispatch("getNews", {
            page: this.page,
            itemsPerPage: this.itemsPerPage
          });
        }

        if (
          parseInt(this.appBuild) >= features.analytics &&
          newValue === false
        ) {
          this.analytics("notifications_inbox", {
            event_action: "dismiss_news_articles",
            school_code: this.schoolCode(this.newsObj.domain),
            school_name: this.schoolName(this.newsObj.domain),
            content_title: this.newsObj.title,
            content_id: this.newsObj.id
          });
        }
      }
    },
    $route: {
      handler(to) {
        if (to.params.id) {
          this.$store
            .dispatch("getIndividualNews", this.$route.params.id)
            .then(() => {
              this.$router.push("/news");
              this.showNewsDetails(this.article);
            })
            .catch(() => {
              this.$route.error = true;
            });
        }
      }
    }
  }
};
export default News;
</script>
<style lang="scss" scoped>
.status-card {
  border-color: #f3631b;
  .school-name {
    white-space: normal;
  }
}
.school-status {
  font-size: 14px;
  font-weight: 500;
}
</style>
